import React from 'react';

/* eslint-disable max-len */
const BeautyIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M13.9843 30.1759H6.40029C6.01629 30.1759 5.69629 29.8559 5.69629 29.4719V24.9599C5.69629 24.5759 6.01629 24.2559 6.40029 24.2559H13.9843C14.3683 24.2559 14.6883 24.5759 14.6883 24.9599V29.4719C14.6883 29.8559 14.3683 30.1759 13.9843 30.1759Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28 25.6641H7.104V28.7681H13.28V25.6641Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9842 25.663H6.40019C6.01619 25.663 5.72819 25.375 5.69619 25.023L4.09619 2.55902C4.09619 2.36702 4.16019 2.17502 4.28819 2.01502C4.41619 1.88702 4.60819 1.79102 4.80019 1.79102H15.5842C15.7762 1.79102 15.9682 1.88702 16.0962 2.01502C16.2242 2.14302 16.2882 2.33502 16.2882 2.55902L14.6882 24.991C14.6562 25.375 14.3362 25.663 13.9842 25.663Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07236 24.2545H13.3124L14.8164 3.23047H5.56836L7.07236 24.2545Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9843 30.1759H6.40029C6.01629 30.1759 5.69629 29.8559 5.69629 29.4719V24.9599C5.69629 24.5759 6.01629 24.2559 6.40029 24.2559H13.9843C14.3683 24.2559 14.6883 24.5759 14.6883 24.9599V29.4719C14.6883 29.8559 14.3683 30.1759 13.9843 30.1759Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28 25.6621H7.104V28.7661H13.28V25.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9842 25.663H6.40019C6.01619 25.663 5.72819 25.375 5.69619 25.023L4.09619 2.55902C4.09619 2.36702 4.16019 2.17502 4.28819 2.01502C4.41619 1.88702 4.60819 1.79102 4.80019 1.79102H15.5842C15.7762 1.79102 15.9682 1.88702 16.0962 2.01502C16.2242 2.14302 16.2882 2.33502 16.2882 2.55902L14.6882 24.991C14.6562 25.375 14.3362 25.663 13.9842 25.663Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07236 24.2545H13.3124L14.8164 3.23047H5.56836L7.07236 24.2545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7521 10.2392C26.5281 10.2392 26.3041 10.1432 26.1761 9.91923L25.5681 9.02323H21.3441C20.9601 9.02323 20.6401 8.70323 20.6401 8.31923C20.6401 7.93523 20.9601 7.61523 21.3441 7.61523H25.9201C26.1441 7.61523 26.3681 7.74323 26.4961 7.93523L27.3281 9.11923C27.5521 9.43923 27.4561 9.88723 27.1361 10.1112C27.0401 10.2072 26.8801 10.2392 26.7521 10.2392Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5281 16.3194C22.2081 16.3194 21.9521 16.0634 21.9521 15.7434V8.35139C21.9521 8.03139 22.2081 7.77539 22.5281 7.77539C22.8482 7.77539 23.1041 8.03139 23.1041 8.35139V15.7434C23.0721 16.0634 22.8162 16.3194 22.5281 16.3194Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1202 15.5517H19.9042C19.5202 15.5517 19.2002 15.2317 19.2002 14.8477V11.9677C19.2002 11.5837 19.5202 11.2637 19.9042 11.2637H25.1202C25.5042 11.2637 25.8242 11.5837 25.8242 11.9677V14.8477C25.8242 15.2317 25.5362 15.5517 25.1202 15.5517Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4159 12.6719H20.6079V14.1439H24.4159V12.6719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9599 30.1753H20.0639C18.1759 30.1753 16.6719 28.6393 16.6719 26.7833V17.5033C16.6719 15.6153 18.2079 14.1113 20.0639 14.1113H24.9599C26.8479 14.1113 28.3519 15.6473 28.3519 17.5033V26.7833C28.3839 28.6713 26.8479 30.1753 24.9599 30.1753Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0641 15.5195C18.9761 15.5195 18.0801 16.4155 18.0801 17.5035V26.7835C18.0801 27.8715 18.9761 28.7675 20.0641 28.7675H24.9601C26.0481 28.7675 26.9441 27.8715 26.9441 26.7835V17.5035C26.9441 16.4155 26.0481 15.5195 24.9601 15.5195H20.0641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3521 7.35938H20.7041V9.31137H24.3521V7.35938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.352 10.0463H20.704C20.32 10.0463 20 9.7263 20 9.3423V7.3583C20 6.9743 20.32 6.6543 20.704 6.6543H24.352C24.736 6.6543 25.056 6.9743 25.056 7.3583V9.3423C25.056 9.7263 24.736 10.0463 24.352 10.0463Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6477 8.0625H21.4077V8.6385H23.6477V8.0625Z",
    fill: "white"
  }));
};

export { BeautyIcon };
